import omit from 'lodash/omit';
import { removeProps } from 'styled-system';
import propTypes from './prop-types';

export default function filterProps(props) {
  return omit(removeProps(props), ['rules', ...Object.keys(propTypes)]);
}
